import { mergeMarketingParamsFromSearch } from '@/lib/marketingContextStorage';
import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Persists allowlisted UTM params from the current URL into sessionStorage for later GET /api/login
 * and GET /api/get-started (appended as query params).
 * When the URL includes any such param, stored values are synced to the query string (omitted keys are cleared).
 * On `/` with no such params, stored marketing context is removed.
 * Uses layout effect so this runs before first paint; otherwise a fast click on "Get started" can navigate to
 * `/api/login` before a passive effect runs, leaving sessionStorage empty and skipping attribution.
 */
export const MarketingContextCapture = () => {
    const location = useLocation();

    useLayoutEffect(() => {
        mergeMarketingParamsFromSearch(location.search, location.pathname);
    }, [location.pathname, location.search]);

    return null;
};
